module Meevo.Plugins.Register {
    "use strict";

    export class OtherPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Other, registerContext, "otherPayments", Register.RegisterSectionCatTypeEnum.Payment);

            this.otherPaymentTypes = _.where(registerContext.paymentTypes, { paymentCategory: Model.PaymentCategoryEnum.Other });
        }

        otherSurcharges: Model.MerchantAccountSurcharge[];
        otherPaymentTypes: any[];
        selectedPaymentType: Model.PaymentTypeListItem;

        selectPaymentType(paymentType: Model.PaymentTypeListItem) {
            this.selectedPaymentType = paymentType;
            this.payment.paymentTypeId = paymentType ? paymentType.id : undefined;
            this.payment.paymentCategory = paymentType ? paymentType.paymentCategory : undefined;
            this.payment.paymentSubCategory = paymentType ? paymentType.paymentSubCategory : undefined;
            this.addSurcharge();
        }

        public addPaymentDisabled() {
            if (!this.selectedPaymentType) {
                return true;
            }

            return super.addPaymentDisabled();
        }

        reset() {
            this.payment = { amount: 0 };
            this.selectedPaymentType = undefined;
        }

        getOtherPaymentTypeImageUrl(otherPaymentType, defaultUrl: string) {
            let fMetadata = <Model.IStorageFile>otherPaymentType;
            if (fMetadata && fMetadata.meevoFile && fMetadata.meevoFile.files && fMetadata.meevoFile.files) {
                let file = _(fMetadata.meevoFile.files).findWhere({ key: "Formated" });
                if (file) {
                    return file.fileUrl;
                }
            }
            return defaultUrl;
        }

        assignSurcharges() {
            const merchantAccountId = this.registerContext.selectedDrawer.merchantAccountId;

            if (!this.registerContext.selectedDrawer.merchantAccountId || this.otherSurcharges ||
                (this.registerContext.selectedDrawer.merchantProviderId !== Model.MerchantAccountProviderEnum.Adyen &&
                    this.registerContext.selectedDrawer.merchantProviderId !== Model.MerchantAccountProviderEnum.AdyenCanada)) {

                return;
            }

            this.registerContext.securityService
                .checkModuleAccess(SecurityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES + SecurityParts.KEY_PART_READ)
                .then(res => {
                    if (res !== Model.SecurityAccessEnum.Grant) {
                        this.otherSurcharges = [];
                        return;
                    }

                    this.registerContext.dataService
                        .customMethodData(`api/MerchantAccount/${merchantAccountId}/Surcharges`, 'GET', null)
                        .then(response => {
                            const surchargeData = response.data;
                            if (!surchargeData.isSurchargeEnabled) {
                                this.otherSurcharges = [];
                                return;
                            }

                            this.otherSurcharges = surchargeData.surcharges.filter(surcharge => surcharge.paymentCategory === Model.PaymentCategoryEnum.Other && surcharge.isEnabled);
                            this.otherSurcharges.forEach(otherSurcharge => {
                                this.otherPaymentTypes.find(otherPaymentType => otherPaymentType.id === otherSurcharge.paymentTypeId).surcharge = otherSurcharge.amount;
                            });
                        });
                });
        }

        addSurcharge() {
            if (!this.otherSurcharges) {
                return;
            }

            const surcharge = this.otherSurcharges.find(otherSurcharge => otherSurcharge.paymentTypeId === this.payment.paymentTypeId);
            if (!surcharge) {
                return;
            }

            this.payment.surcharge = this.registerContext.normalizeDecimalPlaces(this.payment.amount * surcharge.amount);
        }
    }
}